module.exports = __webpack_public_path__ + "static/media/566.0195cf58.webp";